import { useNavigate } from 'react-router-dom';
import { TableColumn } from '../../components/DataTable/TableColumn';
import { TextColumn } from '../../components/DataTable/TextColumn';
import { BasketOwner } from '../../interfaces/Basket/BasketOwner';
import { DateColumn } from '../../components/DataTable/DateColumn';
import { Pagination } from '../../interfaces/Pagination';
import { DataTable } from '../../components/DataTable/DataTable';
import { ButtonColumn } from '../../components/DataTable/ButtonColumn';

const columns: TableColumn<BasketOwner>[] = [
  {
    id: 'user-id',
    name: 'Kullanıcı ID',
    accessor: (row) => <TextColumn value={row.userID.toString()} />,
  },
  {
    id: 'user-name',
    name: 'Ad Soyad',
    accessor: (row) => <TextColumn value={row.userName} />,
  },
  {
    id: 'email',
    name: 'Email',
    accessor: (row) => <TextColumn value={row.email} />,
  },
  {
    id: 'total-quantity',
    name: 'Ürün Adedi',
    accessor: (row) => <TextColumn value={row.totalQuantity.toString()} />,
  },
  {
    id: 'updated-at',
    name: 'Düzenlenme Tarihi',
    accessor: (row) => <DateColumn value={row.updatedAt} />,
  },
  {
    id: 'last-notified-at',
    name: 'Son Hatırlatma Tarihi',
    accessor: (row) => <DateColumn value={row.lastNotifiedAt} />,
  },
];

type BasketOwnersTableProps = {
  basketOwners: BasketOwner[];
  totalCount: number;
  pagination: Pagination;
  onPagination: (newPagination: Pagination) => void;
  onSendNotification: (row: BasketOwner) => void;
};

export const BasketOwnersTable = (props: BasketOwnersTableProps) => {
  const navigate = useNavigate();

  const notificationColumn: TableColumn<BasketOwner> = {
    id: 'notification',
    name: 'Hatırlatma',
    align: 'center',
    accessor: (row) => (
      <ButtonColumn
        label='Gönder'
        onClick={() => props.onSendNotification(row)}
      />
    ),
  };

  return (
    <DataTable
      columns={[...columns, notificationColumn]}
      totalCount={props.totalCount}
      rows={props.basketOwners}
      limit={props.pagination.pageSize}
      setLimit={(newLimit) =>
        props.onPagination({ page: 0, pageSize: newLimit })
      }
      page={props.pagination.page}
      setPage={(newPage) =>
        props.onPagination({ ...props.pagination, page: newPage })
      }
      onClick={(owner) => navigate(`/sales/baskets/${owner.userID}`)}
    />
  );
};
